import React from 'react'
import './LoadingSpinner.css'
const LoadingSpinner = () => {
  return (
    <div className='LoadingSpinner'>
        <img src='/assets/loading-gif.gif' width={"100px"} alt='Loading spinner'></img>
    </div>
  )
}

export default LoadingSpinner